module.exports = __webpack_public_path__ + "img/Westgate Station Concepts_Page_1.f0bebc0f.jpg";